import React from "react";

const InvoicesTable = ({ data, onEdit, onView }) => {
  return (
    <div className="invoices-table-container">
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Customer</th>
            <th>PO No</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((inv) => (
            <tr key={`${inv.docno}-${inv.finyear}`}>
              <td data-label="Invoice No">{inv.docno}</td>
              <td data-label="Date">
                {new Date(inv.docdate).toLocaleDateString("en-GB")}
              </td>
              <td data-label="Customer">{inv.customername}</td>
              <td data-label="PO No">{inv.pono || "-"}</td>
              <td className="actions-cell" data-label="Actions">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onView(inv.docno, inv.finyear)}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoicesTable;
